<form #editCityForm="ngForm">
  <div class="modal-header">
    <h4>Edit City</h4>
    <i class="d-flex justify-content-end icon-ic_delete px-2" (click)="modalRef.hide()" style="cursor: pointer;margin-top: 8px;"></i>
  </div>
  <div class="modal-body">
    <div class="form-group mt-4">
      <strong>Country</strong>
      <input type="text" autocomplete="off" name="country" class="form-control mt-2" #country="ngModel" id="country"
        placeholder="Enter country name" [(ngModel)]="countryName"  readonly>
        <div *ngIf="country.invalid && (country.dirty || country.touched)" class="alert alert-danger">
          <div class="mt-2" *ngIf="country.errors.required">
            country is required.
          </div>
        </div>
    </div>
    <!-- <div class="form-group mt-4">
      <strong>City</strong>
      <div class="mt-2">
        <ngx-select [items]="cityData" disabled optionValueField="cityId" optionTextField="cityName" placeholder="Select"
          (select)="CitySelected" [(ngModel)]="CitySelected" [noAutoComplete]="true"
          [ngModelOptions]="{standalone: true}" required>
        </ngx-select>
      </div>
    </div> -->
  

    <div class="from-group mt-4">
      <strong>City</strong>
      <input type="text" autocomplete="off" class="form-control mt-2"  name="city" #city="ngModel" id="city" placeholder="Enter city name" [(ngModel)]="CityName">
      <div *ngIf="city.invalid && (city.dirty || city.touched)" class="alert alert-danger">
        <div class="mt-2" *ngIf="city.errors.required" >
          City is required.
        </div>
      </div>
     </div>

  <div class="form-group mt-4">
    <strong>Status</strong>
    <span class="icon-radiobutton_active mr-2" *ngIf="selectActiveStatus.isChecked"
      (click)="selectActiveStatus.isChecked = true"></span>
    <span class="icon-radiobutton_inactive mr-2" *ngIf="!selectActiveStatus.isChecked"
      (click)="selectInActiveStatus.isChecked = false ; selectActiveStatus.isChecked = true"></span>
    <span class="mr-3">Active</span>
    <span class="icon-radiobutton_active mr-2" *ngIf="selectInActiveStatus.isChecked"
      (click)="selectInActiveStatus.isChecked = true"></span>
    <span class="icon-radiobutton_inactive mr-2" *ngIf="!selectInActiveStatus.isChecked"
      (click)="selectInActiveStatus.isChecked = true ; selectActiveStatus.isChecked = false"></span>
    <span>Inactive</span>
  </div>
  </div>

  <div class="modal-footer">
    <button (click)="modalRef.hide()" type="button" class="button">
      Cancel
    </button>
    <button (click)="EditCity(city.value)" [disabled]="this.showBtn()"
      class="button blue" type="button">
      Save
    </button>
  </div>
</form>

